import whitelabel from "../../Images/white-label-ai.webp";
import { Link } from "react-router-dom";
import ScrollReveal from "../ScrollReveal/ScrollReveal";
import KineticText from "../KineticText";
import { useParallax } from "../../Hooks/useScrollReveal";

const ParallaxImage = ({ src, alt }) => {
  const ref = useParallax({ speed: 0.1 });
  return (
    <div className="overflow-hidden rounded-lg shadow-xl w-full h-full">
      <img ref={ref} alt={alt} src={src} className="w-full h-[120%] object-cover -mt-[10%]" />
    </div>
  );
};

const HomeSec5 = () => {
  return (
    <div className="flex flex-col xl:flex-row justify-center xl:h-[80vh] items-center w-[90vw] sm:w-[80vw] xl:w-[75vw] mx-auto py-10">
      <ScrollReveal className="w-[100%] sm:w-[80%] p-2 xl:w-[80%] md:p-10 lg:p-16 my-auto" stagger={0.15} direction="up" distance={40}>
        <KineticText splitBy="char" className="text-3xl sm:text-4xl lg:text-5xl font-bold lg:w-[100%] mx-auto mb-10 text-secondary heading-font">
          White Label
        </KineticText>
        <p className="lg:w-[100%] mx-auto text-xl md:text-2xl ">
          Our white label solutions allow you to sell customized products under
          your brand name. We offer a wide range of high-quality products that
          can be branded to reflect your identity, including fragrances, body
          sprays, air fresheners, and more.
        </p>
        <div className="w-[100%] lg:w-[70%] mb-10 mt-6 md:hidden h-[250px]">
          <ParallaxImage
            alt="White Label Manufacture"
            src="https://tomanddarin.com/cdn/shop/files/h3_720x.webp?v=1713344991"
          />
        </div>
        <p className="lg:w-[100%] mx-auto text-xl md:text-2xl mt-6">
          With minimal upfront investment, our white label services let you
          expand your product line quickly and efficiently. We handle the
          production and packaging, while you focus on branding and marketing,
          ensuring a seamless experience from start to finish.
        </p>
        <div className="mt-10">
          <Link
            to="white-label-manufacture"
            className="relative inline-block border border-secondary hover:text-white text-secondary lg:text-secondary bg-white font-bold py-4 px-6 sm:px-10 sm:py-4 rounded-lg overflow-hidden ease-in-out duration-200 border-[2px] group"
          >
            <span className="absolute inset-0 bg-secondary w-0 h-full transition-all duration-500 ease-out group-hover:w-full"></span>
            <span className="relative z-10">Want To Know More?</span>
          </Link>
        </div>
      </ScrollReveal>
      <ScrollReveal variant="clip" className="w-[90%] lg:w-[70%] mb-10 hidden md:block h-[400px] xl:h-[500px]">
        <ParallaxImage
          alt="White Label Manufacture"
          src="https://tomanddarin.com/cdn/shop/files/h3_720x.webp?v=1713344991"
        />
      </ScrollReveal>
    </div>
  );
};

export default HomeSec5;
